'use strict';

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 */
function addSpinner($target) {
    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
    $veil.append(`<div class="spinner"><svg class="spinnerSvgDiamond" xmlns="http://www.w3.org/2000/svg" xmlns:ev="http://www.w3.org/2001/xml-events" version="1.1" viewBox="0 0 407.7 341.8">
			<g>
				<!-- lower -->
				<path class="svgPolyBase" d="M319.6,0H88.1L0,113.4l203.9,228.4,203.8-228.4L319.6,0Z"/>
				<polygon class="svgPoly svgPoly1" points="13 113 105 113 203.9 326.8 13 113"/>
				<polygon class="svgPoly svgPoly2" points="302.7 113 105 113 203.9 326.8 302.7 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="302.7 113 13 113 203.9 326.8 203.9 113" />
				</polygon>
				<polygon class="svgPoly svgPoly3" points="394.7 113 302.7 113 203.9 326.8 394.7 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="302.7 113 105 113 203.9 326.8 302.7 113" />
				</polygon>
				<!-- upper -->
				<polygon class="svgPoly svgPoly4" points="105 113 105 113 93 10 203.9 10 105 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="105 113 13 113 93 10 93 10 105 113" />
				</polygon>
				<polygon class="svgPoly svgPoly5" points="302.7 113 203.9 10 105 113 302.7 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="105 113 93 10 13 113 105 113" />
				</polygon>
				<polygon class="svgPoly svgPoly6" points="302.7 113 314.7 10 394.7 113 302.7 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="105 113 203.9 10 302.7 113 105 113" />
				</polygon>
				<polygon class="svgPoly svgPoly7" points="394.7 113 314.7 10 394.7 113 394.7 113">
					<animate attributeName="points"
					dur=".4s"
					repeatCount="indefinite"
					calcMode="linear"
					keyTimes="0; 0.5; 1"
					to="302.7 113 314.7 10 394.7 113 302.7 113" />
				</polygon>
				<path id="svgPolyOutline" data-name="outline" d="M319.6,0H88.1L0,113.4l203.9,228.4,203.8-228.4L319.6,0ZM203.9,311.8L26,112.6,97.9,20h211.9l71.9,92.6-177.8,199.2Z"/>
			</g>
		</svg><div class="spinnerCircle spinnerCircle_white"></div></div>`);
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}

/**
 * Updates ARIA live region and optional aria-busy attribute.
 * 
 * @param {string} state - "start" or "stop"
 * @param {jQuery} [$target] - Optional element to apply aria-busy to
 */
function updateAriaLoadingState(state, $target) {
    var $ariaRegion = $('.js-aria-live-status');

    if (state === 'start') {
        $ariaRegion.text('Loading, please wait');

        if ($target && $target.length) {
            $target.attr('aria-busy', 'true');
        }
    } else if (state === 'stop') {
        $ariaRegion.text('Loading complete');

        if ($target && $target.length) {
            $target.removeAttr('aria-busy');
        }

        setTimeout(function () {
            $ariaRegion.text('');
        }, 1000);
    }
}

// element level spinner:
$.fn.spinner = function () {
    var $element = $(this);
    var Fn = function () {
        this.start = function () {
            if ($element.length) {
                addSpinner($element);
                updateAriaLoadingState('start', $element);
            }
        };

        this.stop = function () {
            if ($element.length) {
                var $veil = $('.veil');
                removeSpinner($veil);
                updateAriaLoadingState('stop', $element);
            }
        };
    };
    return new Fn();
};

// page-level spinner:
$.spinner = function () {
    var Fn = function () {
        this.start = function () {
            addSpinner($('body'));
            updateAriaLoadingState('start', $('body'));
        };
        this.stop = function () {
            removeSpinner($('.veil'));
            updateAriaLoadingState('stop', $('body'));
        };
    };
    return new Fn();
};
